<template>
    <modal-generic
    sizeClass="medium"
    bigIcon="info"
    :title="t('approvals.operators.create.profilesModal.title')"
    @hideMe="emit('hideMe')">
        <table-generic
        :hasDetail="false"
        :headerData="headerData"
        :tableStyles="tableStyles"
        :tableData="parsedTableData"/>
    </modal-generic>
</template>

<script setup>
import ModalGeneric from '@/components/generic/modals/side/Generic'
import TableGeneric from '@/components/generic/table/Generic'
/* Vue */
import { computed } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'
/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe'])

const { getProfilesForDropdown } = mapGetters(moduleMapper.APPROVALS_OPERATORS)

const profileMapperDataAttr = {
    1: 'approver',
    2: 'collaborator',
    4: 'observer'
}

const headerData = computed(() => {
    const header = [{ label: '', dataAttr: 'name' }]

    getProfilesForDropdown.value.forEach(profile => {
        header.push({
            label: t(`approvals.operators.create.profilesModal.table.${profileMapperDataAttr[profile.id]}`),
            dataAttr: profileMapperDataAttr[profile.id]
        })
    })

    return header
})

const tableStyles = computed(() => {
    const styles = [null]

    getProfilesForDropdown.value.forEach(profile => {
        styles.push({ width: '120px', 'min-width': '120px', 'text-align': 'center' })
    })

    return styles
})

const tableData = [[
    { type: 'description', value: t('approvals.operators.create.profilesModal.table.visualizeOperations'), dataAttr: 'name' },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'approver'
    },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'collaborator'
    },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'observer'
    }
], [
    { type: 'description', value: t('approvals.operators.create.profilesModal.table.startsOperations'), dataAttr: 'name' },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'approver'
    },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'collaborator'
    },
    {
        type: 'status',
        value: { icon: 'block', classes: 'negative align-icon-center' },
        dataAttr: 'observer'
    }
], [
    { type: 'description', value: t('approvals.operators.create.profilesModal.table.approvesOperations'), dataAttr: 'name' },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'approver'
    },
    {
        type: 'status',
        value: { icon: 'block', classes: 'negative align-icon-center' },
        dataAttr: 'collaborator'
    },
    {
        type: 'status',
        value: { icon: 'block', classes: 'negative align-icon-center' },
        dataAttr: 'observer'
    }
], [
    { type: 'description', value: t('approvals.operators.create.profilesModal.table.withdrawSubscription'), dataAttr: 'name' },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'approver'
    },
    {
        type: 'status',
        value: { icon: 'block', classes: 'negative align-icon-center' },
        dataAttr: 'collaborator'
    },
    {
        type: 'status',
        value: { icon: 'block', classes: 'negative align-icon-center' },
        dataAttr: 'observer'
    }
], [
    { type: 'description', value: t('approvals.operators.create.profilesModal.table.deleteOperations'), dataAttr: 'name' },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'approver'
    },
    {
        type: 'status',
        value: { icon: 'check-circle', classes: 'positive align-icon-center' },
        dataAttr: 'collaborator'
    },
    {
        type: 'status',
        value: { icon: 'block', classes: 'negative align-icon-center' },
        dataAttr: 'observer'
    }
]]

const parsedTableData = computed(() => {
    return tableData.map(row => {
        return row.reduce((acc, col) => {
            if (col.dataAttr === 'name') acc.push(col)
            if (getProfilesForDropdown.value.find(profile => profileMapperDataAttr[profile.id] === col.dataAttr)) acc.push(col)
            return acc
        }, [])
    })
})
</script>

<style lang="scss" scoped>
.table-bed {
    margin-top: 19px;
}
</style>
